import { colors } from '@change/ds-tokens';

type Result = ModelHookResult<{
	customEditorConfig: Record<string, unknown>;
	blurbEditorConfig: Record<string, unknown>;
}>;

// eslint-disable-next-line max-lines-per-function
export function useEditorConfig(): Result {
	return {
		data: {
			customEditorConfig: {
				minHeight: 250,
				menubar: false,
				plugins: 'link paste lists emoticons template',
				toolbar: 'bold italic underline fontsize forecolor backcolor | link | bullist emoticons template',
				branding: false,
				inline_boundaries: false,
				resize: true,
				statusbar: false,
				link_title: false,
				paste_as_text: true,
				convert_urls: false,
				relative_urls: false,
				target_list: [{ title: 'New page', value: '_blank' }],
				font_size_formats: '13px 16px 18px 20px 25px',
				color_map: [
					colors.semantic.light.fill['brand strong'], // #f34e49
					'Change.org Red',
					'#FFE600',
					'Yellow',
					colors.semantic.light.background.base, // #ffffff
					'White',
					'#766f81',
					'Gray',
					'#403a49',
					'Black',
				],
				color_cols: 8,
				templates: [
					{
						title: '{{user_preferred_name}}',
						description: 'User Preferred Name',
						content: '{{user_preferred_name}}',
					},
				],
			},
			blurbEditorConfig: {
				content_style: 'body { font-size: 20px; }',
			},
		},
	};
}
